import React, { useEffect, useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useModal, DialogAction } from '../../../function/useModal';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { CompactPicker } from 'react-color';
import { useTranslation } from 'react-i18next';

type ColorPickerProps = {
  color: number;
  setColor: (color: number) => void;
};

const useStyles = makeStyles(
  createStyles({
    container: {
      display: 'flex',
      margin: '4px',
      borderStyle: 'solid',
      borderWidth: '1px',
      height: '20px',
      width: '20px',
    },
  })
);

const ColorPicker: React.FC<ColorPickerProps> = (props: ColorPickerProps) => {
  const classes = useStyles();
  const [colR, setColR] = useState<number>(props.color & 0xff);
  const [colG, setColG] = useState<number>((props.color & 0xff00) >> 8);
  const [colB, setColB] = useState<number>((props.color & 0xff0000) >> 16);
  const [flgDlg, actDlg] = useModal<ColorDialogResponse>();

  const color = flgDlg ? <ColorDialog dialog={actDlg} r={colR} g={colG} b={colB} /> : null;

  useEffect(() => {
    setColR(props.color & 0xff);
    setColG((props.color & 0xff00) >> 8);
    setColB((props.color & 0xff0000) >> 16);
  }, [props.color]);

  return (
    <>
      <div
        className={classes.container}
        style={{ backgroundColor: `rgb(${colR},${colG},${colB})` }}
        onClick={(e) => {
          actDlg
            .open()
            .apply((res: ColorDialogResponse) => {
              props.setColor(res.r + (res.g << 8) + (res.b << 16));
            })
            .cancel(() => {});
        }}
      ></div>
      {color}
    </>
  );
};

type ColorDialogProps = {
  dialog: DialogAction<ColorDialogResponse>;
  r: number;
  g: number;
  b: number;
};

export type ColorDialogResponse = {
  r: number;
  g: number;
  b: number;
};

const DefaultColor: Array<string> = [
  '#FF8080',
  '#FFFF80',
  '#80FF80',
  '#00FF80',
  '#80FFFF',
  '#0080FF',
  '#FF80C0',
  '#FF80FF',
  '#FF0000',
  '#FFFF00',
  '#80FF00',
  '#00FF40',
  '#00FFFF',
  '#0080C0',
  '#8080C0',
  '#FF00FF',
  '#804040',
  '#FF8040',
  '#00FF00',
  '#008080',
  '#004080',
  '#8080FF',
  '#800040',
  '#FF0080',
  '#800000',
  '#FF8000',
  '#008000',
  '#008040',
  '#0000FF',
  '#0000A0',
  '#800080',
  '#8000FF',
  '#400000',
  '#804000',
  '#004000',
  '#004040',
  '#000080',
  '#000040',
  '#400040',
  '#400080',
  '#000000',
  '#808000',
  '#808040',
  '#808080',
  '#408080',
  '#C0C0C0',
  '#400042',
  '#FFFFFF',
];

const ColorDialog: React.FC<ColorDialogProps> = (props: ColorDialogProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [mode, setMode] = useState<boolean>(true);
  const [colR, setColR] = useState<number>(props.r);
  const [colG, setColG] = useState<number>(props.g);
  const [colB, setColB] = useState<number>(props.b);

  return (
    <>
      <Dialog
        open={isOpen}
        fullScreen={false}
        onEntered={(e) => {}}
        onExited={(e) => {
          if (mode) {
            props.dialog.apply({
              r: colR,
              g: colG,
              b: colB,
            });
          } else {
            props.dialog.cancel();
          }
        }}
      >
        <DialogTitle>{t('ColorPicker.色選択','色選択')}</DialogTitle>
        <DialogContent>
          <CompactPicker
            color={{ r: colR, g: colG, b: colB }}
            colors={DefaultColor}
            onChange={(e) => {
              console.log(e.rgb);
              setColR(e.rgb.r);
              setColG(e.rgb.g);
              setColB(e.rgb.b);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => {
              setIsOpen(false);
              setMode(true);
            }}
          >
            {t('ColorPicker.設定','設定')}
          </Button>
          <Button
            onClick={(e) => {
              setIsOpen(false);
              setMode(false);
            }}
          >
            {t('ColorPicker.キャンセル','キャンセル')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ColorPicker;
